export default __webpack_public_path__ + "static/media/valohai-emblem.1a5cdc7f.svg";